import React from 'react';
import { Navigate } from 'react-router-dom';
import { useJoinWaitlistModal } from '../context/ModalContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // const waitlist_email = localStorage.getItem('waitlist_email')
  // const { openJoinWaitlistModal } = useJoinWaitlistModal();
  // if (!waitlist_email || waitlist_email == '') {
  //   openJoinWaitlistModal();
  //   return <Navigate to="/" replace />;
  // }
  return <>{children}</>;
};

export default ProtectedRoute;